/** Keep LVR bands readable when a Windows rewrite turns ≤ / en-dash into junk. */
export function cleanPrintLabel(value: string): string {
  return value
    .replace(/\uFFFD+/g, "?")
    .replace(/(\d)\?{2,}(\d)/g, "$1-$2")
    .replace(/\?{2,}(\d+\s*%)/g, "<=$1")
    .replace(/[–—]/g, "-")
    .replace(/≤/g, "<=")
    .replace(/\?{2,}/g, " ")
    .replace(/\s{2,}/g, " ")
    .replace(/\s+%/g, "%")
    .trim();
}
